import * as actions from './actions';
import mutations from './mutations';
// import getters from './getters';

const state = {
};

export default {
    state,
    // getters,
    actions,
    mutations,
};
